import { useEffect, useRef, useState } from "react";

// 复刻旧 app.js setupTypewriter 的状态机：
// pause-end (1400ms) → erasing → pause-start (250ms) → typing → pause-end ...
// 起始延迟 1200ms，让 hero 整体动画先入场。
const PAUSE_END = 1400;
const PAUSE_START = 250;
const TYPE_SPEED = 55;
const ERASE_SPEED = 30;
const INITIAL_DELAY = 1200;

type State = "typing" | "erasing" | "pause-start" | "pause-end";

export function useTypewriter(words: string[]): string {
  const [text, setText] = useState(words[0] ?? "");
  const wordsRef = useRef(words);
  wordsRef.current = words;

  useEffect(() => {
    if (!words.length) return;
    let wIdx = 0;
    let cIdx = words[0].length;
    let timer: number | undefined;
    let cancelled = false;

    const tick = (state: State) => {
      if (cancelled) return;
      const current = wordsRef.current[wIdx] ?? "";
      if (state === "pause-end") {
        timer = window.setTimeout(() => tick("erasing"), PAUSE_END);
        return;
      }
      if (state === "pause-start") {
        timer = window.setTimeout(() => tick("typing"), PAUSE_START);
        return;
      }
      if (state === "erasing") {
        if (cIdx > 0) {
          cIdx -= 1;
          setText(current.slice(0, cIdx));
          timer = window.setTimeout(() => tick("erasing"), ERASE_SPEED);
          return;
        }
        wIdx = (wIdx + 1) % wordsRef.current.length;
        timer = window.setTimeout(() => tick("pause-start"), 200);
        return;
      }
      // typing
      const next = wordsRef.current[wIdx] ?? "";
      if (cIdx < next.length) {
        cIdx += 1;
        setText(next.slice(0, cIdx));
        timer = window.setTimeout(() => tick("typing"), TYPE_SPEED);
        return;
      }
      timer = window.setTimeout(() => tick("pause-end"), 0);
    };

    timer = window.setTimeout(() => tick("pause-end"), INITIAL_DELAY);
    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
    // words 是常量数组（来自 prop），仅在挂载时启动一次。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return text;
}
